module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av286-c628ea31899fb24c351fc3573551b37f.jpg";